export default __webpack_public_path__ + "static/media/youtube.2ed738af.svg";